export default __webpack_public_path__ + "static/media/AQSPEC_Public.112d39e7.png";